module.exports = __webpack_public_path__ + "static/DEV0-4f95572ca8558fa959ab8d8d746af303.png";